import React, { ReactElement } from 'react'
import { Heading, Pill } from '@scentregroup/ui'
import styles from './index.scss'

interface FiltersLarge {
  children: ReactElement
  countDisplay: string
}

const FiltersLarge = ({
  children,
  countDisplay,
}: FiltersLarge): JSX.Element => (
  <div className={styles.filtersContainer}>
    <Heading
      type="megasmalldivider"
      className={styles.filtersHeading}
      id="filter-heading"
    >
      Filters
    </Heading>
    <div className={styles.countWrapper}>
      <Pill
        className={styles.count}
        type="secondary"
        dataTestId="whats-happening-items-count-large"
      >
        {countDisplay}
      </Pill>
    </div>
    {children}
  </div>
)

export default FiltersLarge
